import { useEffect, useRef, useState } from 'react';

export const useScrollReveal = (direction = 'left', threshold = 0.15) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  const style = {
    opacity: isVisible ? 1 : 0,
    transform: isVisible
      ? 'translateX(0) translateY(0)'
      : direction === 'left'
        ? 'translateX(-60px)'
        : direction === 'right'
          ? 'translateX(60px)'
          : 'translateY(40px)',
    transition: 'opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
  };

  return { ref, style };
};
